import "./styles.css";

import { isAuthenticated } from "./lib/auth";
import { ensureAppTimezone } from "./lib/datetime";
import { initRouter, registerRoute } from "./lib/router";
import { renderLoginPage } from "./pages/login";
import { renderSignalManagementPage } from "./pages/signal_management";
import { renderFolderView } from "./pages/folder_view";
import { renderWikilinksPage } from "./pages/wikilinks";
import { renderDashboardPage } from "./pages/dashboard";
import { renderAccountPage } from "./pages/account";
import { renderGraphPage } from "./pages/graph";
import { renderMySignalsPage } from "./pages/my_signals";
import { renderPulsePage } from "./pages/pulse";
import { renderJudgmentsPage } from "./pages/judgments";
import { renderSignalPage } from "./pages/signal";
import { renderThreadsPage, renderThreadPage } from "./pages/threads";
import { renderStoriesPage, renderStoryPage } from "./pages/stories";
import { renderAdminPage } from "./pages/admin";

registerRoute({ path: "/login", render: renderLoginPage, publicRoute: true });
registerRoute({ path: "/dashboard", render: renderDashboardPage });
registerRoute({ path: "/folders", render: renderFolderView });
registerRoute({ path: "/graph", render: renderGraphPage });
registerRoute({ path: "/my-signals", render: renderMySignalsPage });
registerRoute({ path: "/pulse", render: renderPulsePage });
registerRoute({ path: "/judgments", render: renderJudgmentsPage });
// Exact beats param in findRoute regardless of registration order, so
// /threads can never be swallowed by /threads/:id — see lib/router.ts.
registerRoute({ path: "/threads", render: renderThreadsPage });
registerRoute({ path: "/threads/:id", render: renderThreadPage });
registerRoute({ path: "/stories", render: renderStoriesPage });
registerRoute({ path: "/stories/:id", render: renderStoryPage });
registerRoute({ path: "/signals/manage", render: renderSignalManagementPage });
registerRoute({ path: "/signals/:ref", render: renderSignalPage });
registerRoute({ path: "/wikilinks", render: renderWikilinksPage });
registerRoute({ path: "/admin", render: renderAdminPage });
registerRoute({ path: "/account", render: renderAccountPage });

// Warm the app time zone before the first page paints, so dates do not render
// in the browser's zone and then correct themselves. Signed-in only: /login has
// no token, and a 401 here would bounce the visitor off the page they are on.
if (isAuthenticated()) void ensureAppTimezone();

initRouter();
